module.exports = __webpack_public_path__ + "img/wallet.3e2a8cd8.svg";